import { Page } from '@/core/architecture'

import { ItemCommentTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ItemComment Page
 * Implemented as a practical sample.
 */
export const ItemComment: Page = () => {
  const { state, actions } = useViewModel()

  return <ItemCommentTemplate state={state} {...actions} />
}
